import { render, staticRenderFns } from "./SystemAdapters.vue?vue&type=template&id=bab42b42&scoped=true&"
import script from "./SystemAdapters.vue?vue&type=script&lang=js&"
export * from "./SystemAdapters.vue?vue&type=script&lang=js&"
import style0 from "./SystemAdapters.vue?vue&type=style&index=0&id=bab42b42&lang=scss&scoped=true&"
import style1 from "./SystemAdapters.vue?vue&type=style&index=1&id=bab42b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab42b42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bab42b42')) {
      api.createRecord('bab42b42', component.options)
    } else {
      api.reload('bab42b42', component.options)
    }
    module.hot.accept("./SystemAdapters.vue?vue&type=template&id=bab42b42&scoped=true&", function () {
      api.rerender('bab42b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/SystemAdapters.vue"
export default component.exports